import SeparatorComponent from './SeparatorComponent'

export default SeparatorComponent
